import { graphql } from '@/gql';

graphql(`
  fragment PricingDataFragment on PricingData {
    description
    minAmount
    maxAmount
    customAmount
  }
`);

graphql(`
  fragment CurrencyPricingDataFragment on CurrencyPricingData {
    AUD {
      ...PricingDataFragment
    }
    CAD {
      ...PricingDataFragment
    }
    USD {
      ...PricingDataFragment
    }
  }
`);
